import React from "react";
import { empiTheme } from "./styles/empiTheme";

export default function HowItWorks() {
  return (
    <section id="how" style={section} className="empi-section-tight">
      <div style={wrap}>
        <div style={eyebrow}>How EmPi works</div>
        <h2 style={h2}>Daily guidance, built from your real context.</h2>

        <p style={p}>Each day, EmPi start with the context you share:</p>

        <div style={grid} className="empi-three-col">
          <div style={card}>
            <div style={cardTitle}>Cycle day</div>
            <div style={cardBody}>
              A simple input that helps place today in your cycle context.
            </div>
          </div>

          <div style={card}>
            <div style={cardTitle}>Energy patterns</div>
            <div style={cardBody}>
              How you feel right now — not what an app assumes.
            </div>
          </div>

          <div style={card}>
            <div style={cardTitle}>Your schedule</div>
            <div style={cardBody}>
              So guidance fits real life, not an unrealistic plan.
            </div>
          </div>
        </div>

        <p style={pAfterGrid}>
          And turns that into practical guidance for today:
        </p>

        <ul style={ul}>
          <li>🍽️ what kind of food may support you best today</li>
          <li>🏃 how your body may prefer to move today</li>
          <li>🧠 what kind of focus and expectations fit today’s energy</li>
        </ul>

        <p style={closing}>
          So you don’t have to guess — or treat low-energy days like a personal
          failure.
        </p>
      </div>
    </section>
  );
}

const section = {
  padding: empiTheme.layout.sectionPadding,
  background: empiTheme.colors.background,
};

const wrap = {
  maxWidth: empiTheme.layout.maxWidth,
  margin: "0 auto",
};

const eyebrow = {
  ...empiTheme.typography.eyebrow,
  color: empiTheme.colors.textSecondary,
  marginBottom: 12,
};

const h2 = {
  fontSize: empiTheme.typography.h2.fontSize,
  lineHeight: empiTheme.typography.h2.lineHeight,
  margin: "0 0 16px",
  color: empiTheme.colors.text,
  maxWidth: 700,
};

const p = {
  fontSize: empiTheme.typography.body.fontSize,
  lineHeight: empiTheme.typography.body.lineHeight,
  margin: "0 0 16px",
  color: empiTheme.colors.text,
  maxWidth: 760,
};

const pAfterGrid = {
  fontSize: empiTheme.typography.body.fontSize,
  lineHeight: empiTheme.typography.body.lineHeight,
  margin: "22px 0 14px",
  color: empiTheme.colors.text,
  maxWidth: 760,
};

const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
  gap: 16,
  marginTop: 10,
};

const card = {
  background: empiTheme.colors.surface,
  border: `1px solid ${empiTheme.colors.border}`,
  borderRadius: empiTheme.radius.card,
  padding: 18,
  boxShadow: empiTheme.shadow.card,
};

const cardTitle = {
  fontSize: 14,
  fontWeight: 700,
  marginBottom: 8,
  color: empiTheme.colors.text,
};

const cardBody = {
  fontSize: empiTheme.typography.small.fontSize,
  lineHeight: 1.6,
  color: empiTheme.colors.textSecondary,
};

const ul = {
  margin: "0 0 16px",
  paddingLeft: 22,
  lineHeight: 1.9,
  color: empiTheme.colors.text,
  fontSize: 16,
};

const closing = {
  fontSize: empiTheme.typography.body.fontSize,
  lineHeight: empiTheme.typography.body.lineHeight,
  margin: 0,
  color: empiTheme.colors.text,
  maxWidth: 760,
};
